module.exports = {
    planner: {
        Total: 'Total',
        updateHint: 'Task status will be updated 2 minutes after signing.',
        delete_s: 'Target city deleted successfully.',
        delete_err:
            'Unable to delete target city. Refresh page then try again.',
        Delete: 'Delete',

        RealEstateStrategy: 'Real Estate Strategy',
        Assets: 'Assets',
        SURPLUS: 'Surplus',
        SHORTFALL: 'Shortfall',

        budgetError: 'Please enter city budget.',
        addTargetCityError: 'Fail to add budget city',
        addTargetCitySuccess: 'Add target city successful!',
        selectCity: 'Please select a city',
        AddTargetCity: 'Add Target City',
        SelectInvestmentCity: 'Select your target investment city.',
        EstimateCity: 'Estimate your budget for this city.',
        budegtTitle: "We've provided the average price in case you're unsure.",
        BackToPlanner: 'Back To Planner',

        Expenses: 'Expenses',
        CurrentMonthlyExpenses: 'Current Monthly Expenses',
        RetirementMonthlyExpenses: 'Retirement Monthly Expenses (Est.)',
        RealEstateAllocationTarget: 'Real Estate Allocation Target',

        Target: 'Target',
        TARGETS: 'TARGETS',
        EditTargets: 'Edit Targets',
        YourRealEsatet: 'Your Real Estate Allocation is',
        BaseTotal:
            '* Based on the total value of your properties entered in Portfolio.',
        CurrentlyCalculating: 'Currently Calculating.',
        CalculatingEstate:
            '* We are currently calculating your real estate allocation based on the total value of your properties entered in Portfolio.',
        Confirm: 'Confirm',

        RETIREMENTPROPERTYPORTFOLIO: 'RETIREMENT PROPERTY PORTFOLIO',
        RealEstateAllocation: 'Real Estate Allocation',
        EXISTINGINVESTMENTS: 'EXISTING INVESTMENTS',
        AddProperty: 'Add Property',
        Name: 'Name',
        CurrentValue: 'Current Value',
        GrossYield: 'Gross Yield',
        AnnualCashFlow: 'Annual Cash Flow',
        MortgageFree: 'Not Including Mortgage Payments.',
        ViewDetails: 'View Details',
        TARGETCITIES: 'TARGET CITIES',
        TargetValue: 'Target Value',
        CurrentEquilty: 'Current Equilty',
        CurrentCashFlow: 'Current(Total)',
        TargetAchieved: 'Target Achieved',
        CashFlow: 'Cash Flow(Monthly)',
        RealEstate: 'Real Estate',
        AllOther: 'All Other',

        TOTALS: 'TOTALS',
        TotalAssetsAfter10Years: 'Total Assets After 10 Years (Forecasted)',
        CurrentAllocation: 'Current Allocation',
        ReturnsForecasted: 'Returns Forecasted',
        WEALTHALLOCATIONBREAKDOWN: 'WEALTH ALLOCATION BREAKDOWN',
        TENYEARRETURNFORECAST: '10 YEAR RETURN FORECAST',
        AdjustReturnForecasts: 'Adjust Return Forecasts',
        EditAllocations: 'Edit Allocations',
        AssetType: 'Asset Type',
        AnnGrowth: 'Ann. Growth %',
        AnnYield: 'Ann. Yield %',
        TenYrTotalReturns: '10 Yr Total Returns %',
        TenYrTotalReturnsAmount: '10 Yr Total Returns Amount',

        Growth: 'Growth',
        Yield: 'Yield',
        Cash: 'Cash',
        Stocks: 'Stocks',
        Bonds: 'Bonds',
        RealEstate: 'Real Estate',
        Other: 'Other (Gold, Art, etc.)',
        SaveChanges: 'Save Changes',

        YourWealthAllocation: 'Your Wealth Allocation',
    },

    manage: {
        LearnMore: 'Learn More',
        MaximizeRentalIncome: 'Maximize Rental Income',
        IncreaseYourReturns: 'Increase Your Returns',
        LowerFinancingCosts: 'Lower Financing Costs',
        OptimizeProperty: 'Optimize Your Global Property Portfolio',
        simplifyRentalsMortgages:
            'Let Property Passbook help you simplify your rentals and mortgages.',

        BookaConsultation: 'Book A Consultation',
        ViewPropertyDetails: 'View Property Details',
        MyRequiredActions: 'MY REQUIRED ACTIONS',
        todoList: 'Your to-do list is empty for this property right now.',
        CompletedTask: 'See your completed tasks here',
        receiveList:
            "If you've any completed tasks, it will be reflected here.",
        Milestones: 'MILESTONES',
        COMPLETED: 'COMPLETED',
        Purchase: 'Purchase',
        Mortgage: 'Mortgage',
        Rental: 'Rental',
        MORTGAGE_title: 'See Your Mortgage Milestones Here',
        RENT_title: 'See Your Rent Milestones Here',
        PURCHASE_PROCESS_title: 'See Your Purchase Milestones Here',
        MORTGAGE_desc: 'We’re currently not managing your mortgage',
        RENT_desc: 'We’re currently not managing your rental',
        PURCHASE_PROCESS_desc: 'We’re currently not managing your purchase',
        ActionRequired: 'Action Required',
        ErrorMilestone: 'Error - Action Required',
        OverdueMilestone: 'Action Overdue',
        DueDate: 'Due Date',
        Task: 'Task',
        Status: 'Status',
        Pending: 'Pending',
        Future: 'Future',
        OverDue: 'Overdue',
        Error: 'Error',
        Todo: '',
        Completed: 'Completed',
        Update: 'Update',
        Future_update: 'Future Update',
        BackManage: 'Back to Manage: ',
        BackEvent: 'Back',
        TaskDetails: 'TASK DETAILS',
        MarkComplete: 'Mark as Complete',
        UploadNow: 'Upload Now',
        SignNow: 'Sign Now',
        PayNow: 'Pay Now',
        ConfirmTitle: 'Confirm that task is complete?',
        Confirm_y: 'Yes, Complete',
        UploadFiles: 'Upload Files',
        acceptFile: 'Please upload JPG/PNG/PDF files only',
        deleteFile_s: 'File deleted successfully',
        UploadFile: 'Upload File',
        uploadPrivacy:
            '*Your information is safe. We will not, in any circumstances, share your personal information without your permission.',
        UpdateandComplete: 'Update and Complete',
    },

    UJ: {
        haevAccount: 'Already have an account? Login here',
        currentStep: 'SECTION {currentSection} OF 3',
        back: 'Back',
        welcome: 'Welcome',
        commonDesc: "Let's set up your customized investment plan.",
        question:
            'We’ll ask you some questions for our algorithms to provide more personalized investment recommendations.',
        QTitle1: 'Complete Your Profile',
        QDesc1: 'Let us get to know you better',
        QTitle2: 'Select Your Cities of Interest',
        QDesc2: 'Receive data driven investment recommendations',
        QTitle3: 'Set Your Investment Goals',
        QDesc3: 'Build real estate into your diversified portfolio',
        startBTN: 'Get Started Now',
        totalTimeCostHint: 'This will take less than 3 minutes.',

        first_name: 'First Name',
        last_name: 'Last Name',
        birth: 'Date of Birth',
        gender: 'Gender',
        cityResidence: 'City of Residence',
        nationalityName: 'Nationality',
        currency: 'Preferred Currency',
        placeholder: 'Please Type',

        genderOptions: {
            female: 'Female',
            male: 'Male',
        },

        errorMsg: {
            first_name: 'Please enter first name',
            last_name: 'Please enter last name',
            birth: 'Please select date of birth ',
            gender: 'Please select gender',
            cityResidence: 'Please enter city of residence',
            nationalityName: 'Please select nationality',
            currency: 'Please select currency',
        },

        errorFeedBack: {
            error1: 'Please enter all fields',
            error2: 'Please select at one option',
            error3: 'Please select at least one investing strategy',
            error4: 'Please select at least three cities',
            error5: 'Please select at least three cities',
            error6: 'Please select at one option',
            error7: 'Please select at one option',
            error8: 'Please select at one option',
            error9: 'Please select at one option',
        },

        section1: {
            title: 'Complete Your Profile',
            desc: '',
        },

        section2: {
            title:
                'What would be the primary purpose of your next property purchase?',
            desc: 'Select the answer that best describes your next purchase.',
            buyProperty1: 'Investment Returns in 2-5 Years',
            buyProperty2: 'Build Equity For Retirement',
            buyProperty3: 'Vacation Investment Property',
            buyProperty4: 'Second Home For Family ',
            buyProperty5: 'Primary Residence',
        },

        section3: {
            title:
                'Please select 1-3 investing strategies that best suit your interests.',
            desc:
                'We have grouped the strategies into geographic regions and usage types.',
            buyProperty1: '2-5年内获取投资回报',
            buyProperty2: '退休理财投资',
            buyProperty3: '度假房屋投资',
            buyProperty4: '短期居住使用',
            buyProperty5: '长期居住使用',
        },

        section4: {
            title: 'Select the 3 or more cities you’re most interested in:',
            desc:
                'Diversify your property portfolio across geographies and currencies.',
        },

        section5: {
            title: 'Estimate your budget for each city.',
            desc:
                "We've provided the average price in case you're unsure - Click the next button when you're ready.",
            budget: 'Budget for',
        },

        section6: {
            title: 'What is your desired retirement lifestyle?',
            desc:
                'You may also edit your estimated retirement expenses directly.',
            option1: 'modest',
            option2: 'comfortable',
            option3: 'premium',
            subtitle: 'Your estimated retirement expenses',
            perMonth: 'per month',
        },

        section7: {
            title:
                'Please select a portfolio breakdown closest to your current allocation.',
            desc:
                'Don’t worry, you may change your asset allocation weightings later.',
            realEstate: 'Real Estate {num}',
            bonds: 'Bonds {num}',
            stocks: 'Stocks {num}',
            cash: 'Cash {num}',
            option0: {
                title: 'Aggressive Trader',
                desc:
                    'A majority of my wealth is in stocks, with some real estate investments.',
            },
            option1: {
                title: 'Conservative Saver',
                desc:
                    'Most of my investments are concentrated in real estate and bonds.',
            },
            option2: {
                title: 'Diversified Hands-Off',
                desc:
                    'My assets are evenly distributed between the asset classes.',
            },
            option3: {
                title: 'Just Getting Started',
                desc: 'I split most of my assets between stocks and cash.',
            },
        },

        section8: {
            title:
                'What is your target real estate investment value at retirement?',
            desc:
                'Set a goal for how much real estate you would like to acquire before you retire.',
            subtitle: 'Your target real estate investment value:',
            adjustSlider: 'Adjust slider',
            adjustSliderOrInput: 'Adjust slider or enter a value',
            realEstate: 'Real Estate',
        },

        section9: {
            title: 'Please select your net worth.',
            desc:
                'By understanding your net worth, we can recommend products and services that are best suited for you.',
            option0: 'Below {currency} {symbol} {num1}',
            option1: '{currency} {symbol}{num1} - {num2}',
            option2: '{currency} {symbol}{num1} +',
        },

        section10: {
            skip: 'SKIP',
            title: 'Get Access to Passbook Classic',
            desc:
                'If you have an invitation code, please enter it below to get access to <span>Passbook Classic.</span> This give you access to your personalized global property valuation tracker and rental optimization strategies.',
            invitation_code: 'Invitation Code',
            use_code: 'Use Code',
            enter_code: 'Enter Code',
            apply_title: 'Apply for Passbook Classic',
            apply_desc:
                'Get access to valuations for all your global properties and their rental optimization strategies.',
            apply: 'Apply',
            inputIsEmpty: 'Please enter invitation code.',
            applyMsg:
                "Thank you, we've received your Passbook Classic membership application. We will be in touch within 3 business days.",
            successMsg:
                'Thank you for using your invitation code. Welcome to Passbook Classic!',
            codeExist:
                'The invitation code you used is invalid. Please enter another code or click Apply to request for a new code.',
            codeExist1:
                'The invitation code you used is invalid. Please enter another code.',
            errorMsg: 'Oops.. Something is broken. Try to refresh page.',
        },

        section11: {
            title:
                'Congratulations! Your Property Passbook account set up is complete!',
            desc1:
                'Now you have full access to our website property data analytics and algorithms.',
            desc2:
                '<span>For Passbook Classic members</span>, you may log into the Property Passbook App to get valuations for your global properties.',
            desc4: 'View Your Profile',
        },
    },

    profile: {
        name: 'Name',
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        password: 'Password',
        gender: 'Gender',
        date_of_birth: 'Date Of Birth',
        select_date: 'Select Date',
        nationality: 'Nationality',
        city_of_residence: 'City Of Residence',
        currency: 'Currency',
        preferred_currency: 'Preferred Currency',
        preferred_units: 'Preferred Units',
        male: 'Male',
        female: 'Female',
        upload_avatar: 'Upload Picture',
        upload_limit: 'GIF/JPEG/PNG. Max size of 4MB',
        send_code: 'Send Code',
        save_changes: 'Save Changes',
        current_pwd: 'Current Password',
        new_wd: 'New Password',
        confirm_pwd: 'Confirm Password',
        verification_code: 'Verification Code',
        email_placeholder: 'Email Verification Code',
        phone_placeholder: 'SMS Verification Code',
        select_placeholder: 'Please Select',
        phone_number: 'Phone Number',
        country_code: 'Country Code',
        upgrade_title: 'Membership - Upgrade to Passbook Classic',
        upgrade_subtitle:
            'Get access to valuations for all your global properties and their rental optimization strategies.',
        upgrade: 'Upgrade',

        email_empty: 'Email can not be empty.',
        email_illegal: 'Please enter a valid email address.',
        phone_empty: 'Phone Number can not be empty.',
        phone_illegal: 'Please enter a valid phone number.',

        password_empty: 'Please type your new password.',
        password_diff: 'Password do not match.',
        password_illegal:
            'Your password must contain at least 8 characters and cannot be entirely numeric.',

        empty_msg: {
            first_name: 'Please type first name',
            last_name: 'Please type last name',
            birth: 'Please select date of birth',
            gender: 'Please select gender',
            cityResidence: 'Please type city of residence',
            nationality: 'Please select nationality',
        },
        resend_code: 'Resend code after {timeout}s',

        email_hint:
            '<b>Email change:</b> Enter the verification code sent to your new email.',
        phone_hint:
            '<b>Phone number change</b>: Enter the verification code sent to your new phone number.',

        phone_success: 'Your new phone number was saved successfully.',
        email_success: 'Your new email was saved successfully.',

        verification_error: 'Sorry, your verification code is incorrect.',
        sent_code: 'Verification code has been sent.',
        try_again: 'Oops.. Send fail. Take a try after a few mintues.',
        fields_error: 'Oops.. Some fields went wrong. Please check again.',
        password_success: 'Your password was changed successfully',
        password_error: 'Oops.. Change your password fail. Please check again.',

        file_reader:
            'Your browser does not support FileReader API. Please upgrade your browser or change another one.',

        upload_size_error: 'Upload fail, Image is too big.',
        upload_success: 'Avatar has been changed successfully',
        upload_error: 'Upload fail, Please check your image format or size.',

        remove_success: 'Remove your avatar successfully',
        remove_error: 'Remove fail.. Try to refresh page',
        basic_success: 'Personal information has been updated.',
        basic_error:
            'Personal information went wrong. Please check your information is correct again.',

        code_error: {
            phone_already_used: 'This phone number is already used.',
            email_already_used: 'This email address is already used.',
        },

        benefits: 'See Your Membership Tier Benefits',
        portfolio: 'Portfolio',
        passbook: 'Passbook',
        planner: 'Planner',
        chats: 'Chats',
        profile: 'Profile',
        customer_level: {
            WEB_TRIAL: 'Web Free Version',
            CLASSIC: 'Passbook Classic',
            PREMIER: 'Passbook Premier',
        },
        property: 'My Properties',
        manage: 'Manage',
        planner: 'Investment Planner',
        settings: 'Settings',
    },

    portfolio: {
        title: 'Portfolio',
        addProp: '+ Add Property',
        total_value: 'Total Value',
        total_equity: 'Total equity',
        total_performance: 'Total Performance',
        vs_purchase_price: 'vs purchase price',
        monthly_performance: 'Monthly Performance',
        vs_last_month: 'vs last month',
        yield_current_val: 'Yield on current value',
        yield_purchase_price: 'Yield on purchase price',
        TOTAL_PORTFOLIO_VALUE: 'TOTAL PORTFOLIO VALUE',
        GLOBAL_PORTFOLIO_BREAKDOWN: 'GLOBAL PORTFOLIO BREAKDOWN',
        properties: 'PROPERTIES',
        name: 'Name',
        current_val: 'Current Value',
        monthly_gain: 'Monthly Gain',
        total_gain: 'Total Gain',
        advice: 'Advice',
        Hold: 'Hold',
        Strong_Hold: 'Strong Hold',
        Sell: 'Sell',
        Strong_Sell: 'Strong Sell',
        Not_Calculated: 'Not Calculated',
    },

    property: {
        ManageYourProperty: 'Manage Your Property',
        MortgagePaid: 'Mortgage Paid',
        PropertyValuation: 'Property Valuation',
        PROPERTYVALUATION: 'PROPERTY VALUATION',
        selectProperty: 'Please select one property',
        InternalArea: 'Internal Area',
        floor: 'floor',
        LotSize: 'Lot Size',
        beds: 'beds',
        bathrooms: 'bathrooms',
        kitchen: 'kitchen',
        living: 'living',
        parking: 'parking',
        PurchaseDate: 'Purchase Date',
        CompletionDate: 'Completion Date',
        Completion: 'Completion',
        Ownership: 'Ownership',
        MORTGAGE: 'MORTGAGE',
        Mortgage: 'Mortgage',
        mortgages_startDate: '{year}-{month}',
        noMortgage:
            'No mortgage data. Tap “Edit” to provide mortgage data for this property.',
        noMortgageNull: 'This property does not have a mortgage.',
        StartFrom: 'Start Date:',
        MonPayment: 'Monthly Payment',
        TotalMortgage: 'Total Mortgage',
        InterestRate: 'Interest Rate(%)',
        Length: 'Length',
        Years: 'Years',
        PropertyExpenses: 'PROPERTY EXPENSES',
        Monthly: 'MONTHLY',
        PropertyManagement: 'Property Management',
        RentalManagement: 'Rental Management',
        Tax: 'Tax',
        Insurance: 'Insurance',
        CURRENTVALUE: 'CURRENT VALUE',
        PurchasePrice: 'Purchase Price',
        MonthlyGain: 'Monthly Gain',
        TotalGain: 'Total Gain',
        NoData: 'No Data',
        NoValuation:
            'Your historical valuations are currently being calculated. Please check back soon.',
        CASHFLOW: 'CASH FLOW <span>(MONTHLY)</span>',
        NetCashFlow: 'Net Cash Flow',
        CurrentRent: 'Current Rent',
        NetYield: 'Net Yield',
        MortgageExpenses: 'Mortgage+Expenses',
        PROPERTYOUTLOOK: 'PROPERTY OUTLOOK',
        outlookSuggestion1:
            'Recommended to hold for the next 3-5 years with good expected gains',
        outlookSuggestion2:
            'Recommended to hold for the next 5-10 years with excellent expected gains',
        outlookSuggestion3:
            'Recommended to sell in the next 1-2 years to capitalize on market outlook',
        outlookSuggestion4:
            'Recommended to sell in the next year to capitalize on market outlook',
        outlookSuggestion_no_recommend:
            "Your property's outlook is currently being calculated. Check back soon.",
        RentAnalysis: 'RENT ANALYSIS',
        CurrentlyCalculating: 'Currently Calculating',
        RevenueComparison: 'Revenue Comparison (Monthly) ',
        Edit: 'Edit',
        MonthlyRevenue: 'Monthly Revenue',
        GrossYield: 'Gross Yield',
        AirbnbRentalForecast: 'Airbnb Rental Forecast',
        DailyRate: 'Daily Rate',
        Occupancy: 'Occupancy',
        StandardMonthlyRentalEstimate: 'Standard Monthly Rental Estimate',
        StandardMonthlyRental: 'Standard Monthly Rental',
        AirbnbRental1: 'Airbnb Rental',
        StdMonthlyHint1: ' Standard monthly rental is estimated to provide ',
        StdMonthlyHint2: ' more than Airbnb rental every month.',
        AirbnbRentalHint1: ' Airbnb rental is estimated to provide ',
        AirbnbRentalHint2: ' more than standard monthly rental every month.',
        BookaConsultation: 'Book A Consultation',
        outlookHint1: 'Strong Hold',
        outlookHint2: 'Hold',
        outlookHint3: 'Sell',
        outlookHint4: 'Strong Sell',
        TotalExpense: 'Total Expense',
        NoRentalData:
            'No rental data. Tap “Edit” to provide rental data for this property.',
        NotExistRentalData: 'This property is not receiving rent.',
        House: 'House',
        Townhome: 'Townhome',
        Apartment: 'Condo/Flat/Apartment',
        Commercial: 'Commercial',
        NotSetPropType: 'Not Set Property Type',
    },

    addProperty: {
        placeholder_City: 'City',
        placeholder_address1: '28 Eastwest Road',
        placeholder_address2: 'Upper East Side',
        placeholder_propertyName: 'Seaview Condos',
        placeholder_BuildingA: 'Building A',
        placeholder_shanghai: 'Shanghai',
        placeholder_Jingan: '静安',
        placeholder_buildingName: '汤臣一品',
        placeholder_road: 'Lane 28 Huayuanshiqiao Rd',

        addProp: 'Add Property',
        propCompleted: 'Is the property completed?',
        propCompleted_y: 'Yes, completed',
        propCompleted_n: 'Under construction',
        propCompletedDate: 'When was your property completed?',
        propCompletedDate1: 'More than 1 year',
        propCompletedDate2: 'In the last year',
        propLocation: 'Where is the property located?',
        propLocationPlaceholder: 'Select a country / region',
        propType: 'Please select a property type',
        propTypeApart: 'Condo/Flat/Apartment',
        propTypeHouse: 'House',
        propTypeTownhome: 'Townhome',
        propTypeCommercial: 'Commercial',
        Location: 'Location',
        city: 'City',
        postalCode: 'Post Code(Optional)',
        address: 'Address',
        address1: 'Address Line 1',
        address2: 'Address Line 2(Optional)',
        propertyName: 'Property Name',
        unitNo: 'Unit No. (optional)',
        purchasePrice: 'Purchase Price',
        ownership: 'Ownership',
        ownership_Freehold: 'Freehold',
        ownership_Leasehold: 'Leasehold',
        totalLength: 'Total Length of Leasehold (Years)',
        years: 'year(s)',
        building: 'Building',
        floor: 'Floor',
        district: 'District',
        enterTip: '*Please enter in Simplified Chinese only',
        Layout: 'Layout',
        bedrooms: 'Bedrooms',
        bathrooms: 'Bathrooms',
        livingRooms: 'Living Rooms',
        kitchens: 'Kitchens',
        parkingSpaces: 'Parking Spaces',
        details: 'Details',
        SQM: 'SQM',
        SQFT: 'SQFT',
        InternalArea: 'Internal Area',
        LotArea: 'Lot Area (optional)',
        ExternalArea: 'External Area (optional)',
        FloorOptional: 'Floor (optional)',
        TotalFloor: 'Total Floors (optional)',
        Submit: 'Submit',
        confirm: 'Confirm',
        Congratulations: 'Congratulations!',
        CongratsDesc: 'Your property has been added to your Portfolio Tracker.',
        CongratsDesc1:
            "Your valuation will be ready within 48 hours if you don't receive one instantly. A notification will be sent once completed.",
        AddNewProperty: 'Add Another Property',
        ViewPortfolio: 'View Portfolio',

        selectOne: 'Select one',
        next: 'Next',
        PortfolioTip: 'Portfolio Tip',
        portfolioDeatil:
            'The more complete your property details, the more likely you will receive an instant valuation.',
        PortfolioDetail1:
            'Not to worry - any unclear inputs will be corrected <span>within 48 hours</span> and you will then begin receiving monthly valuations.',
        submitForm: 'Submitting Your Property Information...',
        floorBiggerTotal: 'Floor number should be less than total floor.',

        fieldsError: 'Missing some fields',
        countryError: 'Please choose a country',
        nameError: 'Please enter a property name',
        buildingError: 'Please choose a building',
        addressError: "Please enter your property's address",
        apartmentNumError: 'Please enter an apartment number',
        purchasePriceError: 'Please enter a purchase price',
        yearsOfLeaseholeError:
            'Please enter the no. of years of your leasehold',
        internalError: 'Please enter an internal area',
        SelectOption: 'Please select an option',
        MonthlyRentalError: 'Please enter monthly rental',
        lotAreaError: 'Please enter a lot area',
        floorError: 'Please enter a unit floor',
        ownershipError: 'Please choose ownership',
        cityError: 'Please enter a city',
        districtError: 'Please enter a district',
    },

    editProp: {
        backTo: 'Back To Property',
        editSuccess: 'Change successful!',
        Yes: 'Yes',
        No: 'No',
        propMortgaged: 'Property Mortgaged?',
        monthlyMortgaged: 'Monthly Mortgage',
        totalMortgaged: 'Total Mortgage',
        intRateMortgaged: 'Mortgage Interest Rate (%)',
        startDate: 'Start Date',
        amortizationPeriod: 'Amortization Period',
        selectDatePlaceholder: 'Select Date',
        propRented: 'Property Rented Out?',
        avgMontlyRent: 'Avg. Monthly Rent',
        expenseTracking: 'Expenses Tracking (Avg. Monthly)',
        propManage: 'Property Management',
        propTax: 'Property Tax',
        rentalManageService: 'Rental Management Service',
        propInsurance: 'Property Insurance',
    },

    searchResultPage: {
        loading: 'Loading',
        header_region: 'Toronto Apartment',

        dropdown: 'Select a City',

        projectType: {
            name: 'Project Type',
            Apartment: 'Condo / Apartment',
            Villa: 'Single Family / Villa',
            Terrace: 'Townhome / Terrace',
            Multiple: 'Multiple',
            All: 'All',
        },

        avgPrice: {
            name: {
                sqft: 'Price / SQFT',
                sqm: 'Price / SQM',
            },
            text: {
                sqft: 'price/sqft',
                sqm: 'price/sqm',
            },
            avgPrice: 'The average {unit_en} is {currency}{price_area_avg}',
            clear: 'clear',
            apply: 'apply',
        },

        startingPrice: {
            name: 'Starting Price',
            avgPrice: 'The average price is ',
            clear: 'clear',
            apply: 'apply',
        },

        applyFilters: 'Apply Filters',

        applyFilters_sm: 'Apply',

        top10: 'Top 10%',

        loadMore: 'Load More',

        resultCount: 'Showing {count} total results',

        noResult: 'No results. See below for other projects in {region}',

        resultHint: 'Try adjusting your search filters to get more results.',

        removeFilters: 'Remove all filters',

        Filters: 'Filters',

        overall: 'Overall Score',

        card: {
            sqft: 'SQFT',
            sqm: 'SQM',
            startingPrice: 'Starting Price',
        },

        placeholder: {
            header_input: 'Select a City',
            mobile_input: 'Select region',
        },

        heatmapMode: 'Momentum Heatmap',

        clearAll: 'Clear All',

        scorebox: {
            rank: 'City Rank',
            score: 'City Score',
            median_price: 'Median Price',
            gross_yield: 'Gross Yield',
            score_tooltip:
                'The cumulative scoring of residential real estate investment attributes per city.',
            rank_tooltip:
                'City Rank is determined by the City Score, released monthly by Property Passbook.',
        },

        highest: 'Highest',
        momentumScoere: 'Momentum Score',
        lowest: 'Lowest',

        viewMap_btn: 'View on Map',
        viewProject_btn: 'View Project',
        overall_score: 'Overall Score',

        // viewProject: "View Project"
    },

    reservationSelectUnit: {
        title: 'Select a Unit Type',
        alert: 'Please select a unit type(s) to reserve.',
    },

    reservationPayment: {
        method: 'Select a Payment Method',
        promise:
            'All transactions are secure and encrypted. Credit card information is never stored.',
        creditCard: 'Credit Card',
        creditCard1: 'CARD NUMBER',
        creditCard2: 'NAME ON CARD',
        creditCard3: 'EXPIRY DATE',
        creditCard4: 'CVV',
        creditCard_msg1:
            'The last 3 digits displayed on the back of your card.',
        creditCard_msg2:
            'Unable to make payment due to invalid credit card information. Please try again. ',
        available: '(Only available when paying in Chinese Yuan.)',
        scanQR: 'Scan to pay',
        wechat: 'Wechat',
        scanWechat: 'Scan the QR code with Wechat to make a reservation',
        alipay: 'Alipay',
        scanAlipay: 'Scan the QR code with AliPay to make a reservation',
        promise1: 'Your information is Safe',
        promise2:
            'We will not sell or rent your personal information for any marketing purposes.',
        promise_title1: 'Secure Checkout',
        promise_title2:
            'All information is encrypted and transmitted without risk using a',
        promise_title2_hint: 'SSL (Secure Sockets Layer)',
        promise_title2_1: 'protocol.',
    },

    reservationConfirm: {
        thanks: 'Thank',
        thanks_1: 'You',
        confirmed: 'Your Reservation is',
        confirmed_1: 'Confirmed',
        confirmed_2: '!',
        contact:
            "We're currently processing your request. An email with instructions on your next steps will be sent within the next 24 hours.",
        backHome: 'Back Home',
    },

    reservation: {
        // "q":"?",
        step_1: 'Select Unit Type',
        step_2: 'Reservation Payment',
        step_3: 'Reservation Confirmed',
        back: 'Back to',
        backToUnit: 'Back to Unit Type',
        unitReservation: 'Unit Reservation',
        waiver: 'Have a ',
        waiver_1: 'Reservation Waiver?',
        waiver_msg: 'Enter a waiver code to waive your reservation payment.',
        apply: 'Apply',
        subTotal: 'Subtotal',
        reservationWaiver: 'Reservation waiver',
        remove: 'remove',
        total: 'Total',
        used: 'How is my reservation used?',
        rApplied: 'Your reservation will be applied towards your',
        rApplied_1: 'First Payment',
        noReservation: 'No Reservation Fee Needed',
        free: 'Your reservation fee has been ',
        free_1: 'waived',
        symbol: '!',
        purchase:
            'Your purchase is only finalized on contract signing. Unit reservation does not guarantee your purchase.',
        next: 'Next',
        reserve: 'Reserve Now',
        privacy1: 'By clicking “Reserve Now”, I agree to Property Passbook’s',
        privacy2: 'Terms of Use',
        privacy2_1: 'and',
        privacy2_2: 'Privacy Policy',
        enterWaiver: 'Enter a reservation waiver number',
        selectHint: 'Please select one unit type',
    },

    reservation_h5: {
        wechat: 'Add Wechat',
        scanCode: 'Scan the QR code ',
        scanWechat: 'with Wechat mobile app to make a reservation.',
        alipay: 'Add Alipay',
        scanAlipay: 'with Alipay mobile app to make a reservation. Or',
        redirect: 'input Alipay account info.',
    },

    citySelection: {
        asia: 'Asia Pacific',

        asia1: 'Auckland',
        asia2: 'Manila',
        asia3: 'Bangkok',
        asia4: 'Melbourne',
        asia5: 'Beijing',
        asia6: 'Pattaya',
        asia7: 'Brisbane',
        asia8: 'Perth',
        asia9: 'Chiang Mai',
        asia10: 'Phuket',
        asia11: 'Dubai',
        asia12: 'Rayong-Koh Samet',
        asia13: 'Ho Chi Minh City',
        asia14: 'Shanghai',
        asia15: 'Hong Kong',
        asia16: 'Singapore',
        asia17: 'Hua HIn-Cha Am',
        asia18: 'Sydney',
        asia19: 'Koh Samui',
        asia20: 'Krabi',

        europe: 'Europe',

        europe1: 'Barcelona',
        europe2: 'Berlin',
        europe3: 'Birmingham',
        europe4: 'Brussels',
        europe5: 'Frankfurt',
        europe6: 'Lisbon',
        europe7: 'Liverpool',
        europe8: 'London',
        europe9: 'Madrid',
        europe10: 'Manchester',
        europe11: 'Paris',

        northAmerica: 'North America',

        northAmerica1: 'Atlanta',
        northAmerica2: 'Montreal',
        northAmerica3: 'Austin',
        northAmerica4: 'New York City',
        northAmerica5: 'Boston',
        northAmerica6: 'Orlando',
        northAmerica7: 'Calgary',
        northAmerica8: 'Ottawa',
        northAmerica9: 'Dallas',
        northAmerica10: 'San Francisco',
        northAmerica11: 'Hamilton',
        northAmerica12: 'San Jose',
        northAmerica13: 'Houston',
        northAmerica14: 'Seattle',
        northAmerica15: 'Kelowna',
        northAmerica16: 'Toronto',
        northAmerica17: 'Kitchener-Waterloo',
        northAmerica18: 'Vancouver',
        northAmerica19: 'Los Angeles',
        northAmerica20: 'Victoria',
        northAmerica21: 'Miami',
        northAmerica22: 'Washington DC',
    },

    cityRanking: {
        title: 'Real Estate Investment City Rankings - ',
        subTitle:
            "Property Passbook's Investment City Rankings covers major established and emerging markets and tracks a broad range of factors to identify cities that have the strongest residential real estate and socio-economic momentum. Check back every month for an update!",
        cityRank: 'City Rank',
        city: 'City',
        cityScore: 'City Score',
        tooltip:
            'The cumulative scoring of residential real estate investment attributes per city',
        avgGrowth: '5YR AVG Pop Growth',
        medianPrice: 'Median Price',
        grossYield: 'Gross Yield',
        select: 'Select12',
        selectOne: 'Select One',
        noResult: 'No Result',
        all: 'All ',
        allCountry: 'All Countries',
    },

    cityRanking_selection: {
        cancel: 'Cancel',
        timeframe: 'Select A Timeframe',
        done: 'Done',
        comparison: 'Select A Comparison',
        selectRegion: 'Select A Region',
        continets: 'Continents',
        countries: 'Countries',
    },
};



//////////////////
// WEBPACK FOOTER
// ./lang/en.js
// module id = n8F9
// module chunks = 0